import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Demo from "../pages/Demo";
import SearchPage from "../pages/Admin/SearchPage";
import CartViewPage from "../pages/Admin/CartViewPage";

import Offboarding from "../pages/Admin/Offboarding";
import EmployeeSearch from "../pages/Admin/EmployeeSearch";
import ViewPage from "../ProfileForm/ViewPage";
import AdminNavBar from "../component/AdminNavBar";
import UserNavBar from "../component/UserNavBar";
import SuperUserNavBar from "../component/SuperUserNavBar";
import UserCreationPage from "../pages/UserCreationPage";
import UserView from "../pages/UserView/UserView";
import Layout from '../component/Layout';
import ComplianceDashboard from "../pages/Admin/ComplianceDashboard";
import ForgotPasswordPage from "../pages/ForgotPasswordPage";
import ResetPasswordPage from "../pages/ResetPasswordPage";
import LoginPage from "../pages/LoginPage"; // ✅ Import Login page
import JobSearch from "../components/SkillsetRepository/Jobsearchgrid";
import ChangePasswordPage from "../pages/ChangePasswordPage";

import PasswordChangedPage from "../pages/PasswordChangedPage"; // ✅ Import Password Changed page
import LandingPage from "../pages/LandingPage";
import SkillRepo from "../components/SkillsetRepository/SkillRepo";
import EditSkillRepo from "../components/SkillsetRepository/EditSkillRepo";

import EmployeeSkillSetSearch from "../pages/Admin/EmployeeSkillSetSearch";
import ResetLogin from "../components/Login/ResetLogin";
import AccountActivity from "../pages/Admin/Activity/AccountActivity"
import JobCreationForm from "../components/JobCreationForm/JobCreationForm";
import UserAccountActivity from "../pages/UserAccountActivity";
import UserJobSearch from "../pages/SearchJob";
import TrainingPortal from "../pages/Admin/TrainingPortal";
import UserTrainingSearch from "../pages/UserTrainingSearch";
import UserAttendedTrainings from "../pages/UserView/User_Attended/UserAttendedTrainings";
// const submoduleDeployment = process?.env?.SUB_APP_DEPLOYMENT === 'YES'
const submoduleDeployment = 'YES'
export const subRoute = [
  {
    path: "/user-management/Onboarding",
    element: (
      <Layout>
        <SearchPage />
       </Layout> 
    ),
  },
  {
    path: "/cart",
    element: (
        <Layout>
        <CartViewPage />
        </Layout>
    ),
  },
  {
    path: "/redux-demo",
    element: <Demo />
  },
  {
    path:"/search/employees",
    element: <EmployeeSearch />
  },
  
  
  {
    path:"/search/skillSet",
    element: <EmployeeSkillSetSearch />
   
  },
  {
    path: "/AdminNavBar",
    element: <AdminNavBar />
  },
  {
    path: "/SuperUserNavBar",
    element: <SuperUserNavBar />
  },
  {
    path: "/UserNavBar",
    element: <UserNavBar />
  },
  
  {
    path: "/ViewPage/:id",
    element: <ViewPage />
  },
  {
    path: "/ViewPage",
    element: <ViewPage />
  },
  {
    path: "/user/:id",
    element: <ViewPage />
  },
 {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/",
    element: <LoginPage />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPasswordPage />,
  },
  {
    path: "/reset-password/:token",
    element: <ResetPasswordPage />,
  },

  {
    path: "/reset-login",
    element: <ResetLogin />,
  },

  {
    path: "/reset-password",
    element: <ResetPasswordPage />,
  },


  {
    path: "/change-password",
    element: <ChangePasswordPage />,
  },


  {
    path: "/password-changed",
    element: <PasswordChangedPage />, // ✅ Correct JSX usage
  },
  {
    
    path: "/superuser-dashboard",
    element: <LandingPage />,
  },
  {
    
    path: "/adminuser-dashboard",
    element: <LandingPage />,
  },
  {
    
    path: "/normaluser-dashboard",
    element: <LandingPage />,
  },
  {
    
    path: "/user-maintenance/add-user",
    element: <UserCreationPage />,
  },


  
  {
    path: "/offboarding/:userToken",
    element: <Offboarding/>
  },
/* User View Onboarding Page*/
  {
    path: "/UserView",
    element: <UserView />
  },
  /* User View skillset Page*/
  {
    path: "/SkillRepo",
    element: <SkillRepo/>
  },
  

  {
    path: "/EditSkillRepo",
    element: <EditSkillRepo/>
  },
  {
    path: "/activity/accountActivity",
    element: (
        <Layout>
        <AccountActivity />
        </Layout>
    ),
  },
 

  {
    path: "/jobs/create-job",
    element: (
      <Layout>
        <JobCreationForm />
      </Layout>
    ),
  },
  {
    path: "/useraccountactivity",
    element:(
      <Layout><UserAccountActivity/></Layout>)
  },

  {
    path: "/jobs/search",
    
    element:(
    <Layout>
    <JobSearch/>
    </Layout>
    )
  },
  {
    path: "/SearchJob",
    element: (
      <Layout>
        <UserJobSearch />
      </Layout>
    )
  },
  {/*Training portal for Normal user view */
    path: "/SearchTraining",
    element: (
      <Layout>
        <UserTrainingSearch />
      </Layout>
    )
  },
  {
    path: "/attendedtrainings",
    element:
      <UserAttendedTrainings/>
  },

  {
    path: "/training/trainingportal",
    element:<TrainingPortal/>
  },
  /* Compliance dashboard Page*/
  {
    path: "/dashboard/compliance-dashboard",
    element: <ComplianceDashboard />
  }
];





if(submoduleDeployment) {
  subRoute.forEach(sr => {
    sr.path = sr.path.substring(1,sr.path.length)
  })
}
const router = createBrowserRouter(subRoute);
function Path() {
  return <RouterProvider router={router} />;
}
 



export default Path;
